<template>
  <div>
    <div v-if="$page.props.auth.user.rol =='Admin'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('users')">
        <icon name="users" class="w-4 h-4 mr-2" :class="isUrl('users') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('users') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Usuarios</div>
      </inertia-link>
    </div>
    <div v-if="$page.props.auth.user.rol =='Admin' || $page.props.auth.user.rol =='Granja'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('animales')">
        <icon name="cheveron-right" class="w-4 h-4 mr-2" :class="isUrl('animales') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('animales') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Animales</div>
      </inertia-link>
    </div>   
    <div v-if="$page.props.auth.user.rol =='Admin' || $page.props.auth.user.rol =='Granja'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('razas')">
        <icon name="cheveron-right" class="w-4 h-4 mr-2" :class="isUrl('razas') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('razas') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Raza de Animales</div>
      </inertia-link>
    </div>   
    <div v-if="$page.props.auth.user.rol =='Admin' || $page.props.auth.user.rol =='Granja'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('especies')">
        <icon name="cheveron-right" class="w-4 h-4 mr-2" :class="isUrl('especies') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('especies') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Especies de Animales</div>
      </inertia-link>
    </div> 
    <div v-if="$page.props.auth.user.rol =='Admin' || $page.props.auth.user.rol =='Granja'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('tecnicos')">
        <icon name="cheveron-right" class="w-4 h-4 mr-2" :class="isUrl('tecnicos') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('tecnicos') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Técnicos-Veterinarios</div>
      </inertia-link>
    </div> 
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import DropdownMenu from '@innologica/vue-dropdown-menu'

export default {
  components: {
    Icon,
    DropdownMenu
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter(url => currentUrl.startsWith(url)).length
    },
  },
}
</script>
